<template>
    <table class="vrm-table">
        <thead>
            <slot name="thead" />
        </thead>
        <tbody v-if="entries.length">
            <template v-for="entry in entries">
                <tr
                    v-if="onClickRow"
                    :key="'main' + entry.key + keyUniqueString"
                    :class="{ 'is-expanded': entry.expanded && !removeExpandableClass }"
                    @click="onClickRow(entry.key)"
                >
                    <slot name="main" v-bind="entry" />
                </tr>
                <tr
                    v-else
                    :key="'main' + entry.key + keyUniqueString"
                    :class="{ 'is-expanded': entry.expanded && !removeExpandableClass }"
                >
                    <slot name="main" v-bind="entry" />
                </tr>
                <tr
                    v-if="entry.expanded"
                    :key="'extra' + entry.key + keyUniqueString"
                    class="vrm-table__collapse"
                    :class="{ 'is-expanded': entry.expanded && !removeExpandableClass }"
                >
                    <slot name="extra" v-bind="entry" />
                </tr>
            </template>
        </tbody>
        <tbody v-else>
            <tr>
                <td colspan="9999">
                    <slot name="noEntries">
                        {{ $t('users.no_entries', { i18nFallback: 'No entries in this table' }) }}
                    </slot>
                </td>
            </tr>
        </tbody>
        <tfoot>
            <slot name="tfoot" />
        </tfoot>
    </table>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class VrmFoldableTable extends Vue {
    @Prop({ type: Array })
    items;
    @Prop({ type: String, default: 'id' })
    keyBy;
    @Prop({ type: String, default: 'random' + Math.random() })
    keyUniqueString;
    @Prop({ type: Array, default: () => [] })
    expanded;
    @Prop({ type: Array, default: () => [] })
    colWidths;
    @Prop({ type: Function })
    onClickRow; // receives the keyBy as argument
    @Prop({ type: Boolean, default: false })
    removeExpandableClass;
    @Prop({ type: Function })
    sortCompareFunction;

    get entries() {
        let items = this.items;
        if (!!items && this.sortCompareFunction) {
            items.sort(this.sortCompareFunction);
        }
        return items.map(item => {
            const key = this.keyBy.length > 0 ? item[this.keyBy] : item;
            return {
                key,
                item,
                expanded: this.isExpanded(key),
                toggle: () => this.toggle(key),
            };
        });
    }

    toggle(itemId) {
        const index = this.expanded.indexOf(itemId);
        if (index >= 0) {
            this.expanded.splice(index, 1);
        } else {
            this.expanded.push(itemId);
        }
    }

    isExpanded(itemId) {
        return this.expanded.includes(itemId);
    }
}
</script>
